import type { SyntheticEvent } from 'react';
import { observer } from 'mobx-react-lite';
import { Alert, Snackbar } from '@mui/material';

import { toastStore } from '../../stores/ToastStore';

const ToastHost = observer(() => {
	const currentToast = toastStore.current;
	const topOffsetPx = 32;
	const isErrorToast = currentToast?.variant === 'error';

	const handleClose = (_event?: SyntheticEvent | Event, reason?: string) => {
		// For persistent errors, only explicit close button click should dismiss.
		if (isErrorToast) return;
		if (reason === 'clickaway') return;
		toastStore.dismissCurrent();
	};

	return (
		currentToast ? (
			<Snackbar
				key={currentToast.id}
				open
				autoHideDuration={isErrorToast ? null : currentToast.duration}
				onClose={handleClose}
				anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
				sx={{
					'&.MuiSnackbar-root': {
						top: `calc(var(--header-height, 56px) + ${topOffsetPx}px) !important`,
					},
				}}
			>
				<Alert
					onClose={() => toastStore.dismissCurrent()}
					severity={currentToast.variant}
					variant='filled'
					sx={{
						width: '100%',
						'& .MuiAlert-message': {
							whiteSpace: 'pre-line',
						},
					}}
				>
					{currentToast.message}
				</Alert>
			</Snackbar>
		) : null
	);
});

export default ToastHost;